// Import polyfills FIRST before any other modules
import './polyfills'

import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import App from './App'
import { loginSuccess, logout } from './redux/slices/userSlice'
import store from './redux/store'
import authService from './services/auth.service'
import './i18n/config' // Initialize i18n

// Import Shadcn UI global styles
import './styles/globals.css'
import './styles/theme.css'

// Create the root element
const root = ReactDOM.createRoot(document.getElementById('root')!)


// Check if there's a user in localStorage and initialize the Redux store
const storedUser: any = authService.getCurrentUser()

// Initialize the Redux store with user data or mark as initialized with no user
if (storedUser && storedUser.user && storedUser.accessToken) {

  // Dispatch the loginSuccess action to set the user in the Redux store
  store.dispatch(loginSuccess({
    user: storedUser.user,
    accessToken: storedUser.accessToken
  }))


  // Also restore Feathers authentication
  authService.restoreAuthentication().then(async authResult => {
    if (!authResult.isValid) {
      // If token is invalid/expired, clear the state
      store.dispatch(logout())
    } else {
      // Update Redux with fresh user data from DB
      if (authResult.user) {
        // We can just use loginSuccess again, or a new action. 
        // We'll use a standard dispatch to update the user
        store.dispatch({ type: 'user/updateUser', payload: authResult.user });
      }

      // RESTORE DISCOVERY DATA (for Organization Switcher)
      try {
        const storedOrgs = localStorage.getItem('discovered_organizations');
        const storedIST = localStorage.getItem('intermediate_session_token');

        if (storedOrgs) {
          const orgs = JSON.parse(storedOrgs);
          if (Array.isArray(orgs)) {
            // We need to import the action dynamically or add it to imports
            store.dispatch({ type: 'organization/setDiscoveredOrganizations', payload: orgs });
          }
        }

        if (storedIST) {
          store.dispatch({ type: 'organization/setIntermediateSessionToken', payload: storedIST });
        }

        // FETCH CURRENT ORGANIZATION DATA (always fetch fresh, no localStorage caching)
        // This ensures we always have the latest data including logo URL with signed URL
        const organizationService = await import('./services/organization.service');
        const currentOrg = await organizationService.default.getCurrentOrganization();
        store.dispatch({ type: 'organization/setCurrentOrganization', payload: currentOrg });
        console.log('✅ Fetched current organization:', currentOrg.name, currentOrg.logoUrl ? 'with logo' : 'no logo');
      } catch (e) {
        console.error('Failed to restore discovery/organization data:', e);
      }
    }
  })
} else {
  // Even if there's no user, we need to mark the state as initialized
  // to prevent the loading screen from showing indefinitely
  store.dispatch({ type: 'user/setInitialized', payload: true })
}

// Render the app
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
)
